/**
 * Configurable bid cost settings (mileage rate + debris cost per quarter-truck),
 * supervisor/admin-editable. Drives the bid calculator (§A).
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CostSettings, CostSettingsUpdate } from '@vari-crew/schemas';
import { apiCall } from '@/lib/api';

const KEY = ['cost-settings'] as const;

export function useCostSettings(enabled = true) {
  return useQuery<CostSettings>({
    queryKey: KEY,
    enabled,
    queryFn: () => apiCall<CostSettings>('/cost-settings'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateCostSettings() {
  const qc = useQueryClient();
  return useMutation<CostSettings, Error, CostSettingsUpdate>({
    mutationFn: (body) => apiCall<CostSettings>('/cost-settings', { method: 'PUT', body }),
    onSuccess: (s) => qc.setQueryData(KEY, s),
  });
}
